// console.log(`js/01-pageSection/scheduleMobile.js is working`);

let schedule = document.querySelector(`.page-section-schedule`);
let mobileClasses = document.querySelectorAll(`.mobile-classes`);
let mobileClassesByClassNames = document.querySelectorAll(
  `.mobile-classes > .mobile-day-class`
);
let programSelect = document.querySelector(`.program-select`);
let programSelectClassNames = document.querySelectorAll(
  `.program-select-class-name`
);
let showAllOption = document.querySelector(`.show-all-mobile`);
let allGridItems = document.querySelectorAll(`.schedule-day > div`);

if (schedule) {
  cleanMobileSchedule();
  programSelectClassNames.forEach((programSelectClassName) => {
    programSelectClassName.addEventListener(
      `click`,
      updateProgramSelectContent
    );
    programSelectClassName.addEventListener(
      `click`,
      addDisplayNoneMobileClasses
    );
  });
  showAllOption.addEventListener(`click`, showAllMobileClass);
}

function cleanMobileSchedule() {
  mobileClasses.forEach((mobileClass) => {
    let mobileNodes = mobileClass.childNodes.length;
    if (mobileNodes === 0) {
      mobileClass.parentNode.removeChild(mobileClass.previousElementSibling);
      mobileClass.parentNode.removeChild(mobileClass);
    }
  });
  showAllMobileClass();
}

function updateProgramSelectContent() {
  let programSelected = this.textContent;
  programSelect.textContent = programSelected;
}

function showAllMobileClass() {
  allGridItems.forEach((gridItem) => {
    gridItem.classList.remove(`hide`);
    gridItem.classList.add(`show`);
  });
  mobileClassesByClassNames.forEach((mobileClassesByClassName) => {
    mobileClassesByClassName.classList.remove(`hide`);
    mobileClassesByClassName.classList.add(`show`);
  });
}

function addDisplayNoneMobileClasses() {
  let programSelectedCSSClass = this.classList[2];
  mobileClassesByClassNames.forEach((mobileClassesByClassName) => {
    let mobileClassesByClassNameCSSClass =
      mobileClassesByClassName.classList[1];
    if (
      programSelectedCSSClass === mobileClassesByClassNameCSSClass ||
      programSelectedCSSClass === `show-all-mobile`
    ) {
      mobileClassesByClassName.classList.add(`show`);
      mobileClassesByClassName.classList.remove(`hide`);
    } else {
      mobileClassesByClassName.classList.remove(`show`);
      mobileClassesByClassName.classList.add(`hide`);
    }
  });
  emptyMobileRows();
}

function emptyMobileRows() {
  let updatedMobileClasses = document.querySelectorAll(`.mobile-classes`);
  updatedMobileClasses.forEach((updatedMobileClass) => {
    let updatedMobileClassChildNodes = updatedMobileClass.childNodes;
    let mobileCSSClassArray = [];
    updatedMobileClassChildNodes.forEach((updatedMobileClassChildNode) => {
      if (updatedMobileClassChildNode.classList.contains(`show`)) {
        mobileCSSClassArray.push(`show`);
      } else {
        mobileCSSClassArray.push(`hide`);
      }
    });
    if (!mobileCSSClassArray.includes(`show`)) {
      updatedMobileClass.classList.add(`hide`);
      updatedMobileClass.previousElementSibling.classList.add(`hide`);
      updatedMobileClass.classList.remove(`show`);
      updatedMobileClass.previousElementSibling.classList.remove(`show`);
    } else {
      updatedMobileClass.classList.add(`show`);
      updatedMobileClass.previousElementSibling.classList.add(`show`);
      updatedMobileClass.classList.remove(`hide`);
      updatedMobileClass.previousElementSibling.classList.remove(`hide`);
    }
  });
}
